<template lang="pug">
  //- container for btns that appear at bottom edge on mobile (menu, cart, shop-filters)
  //- allows better markup so btn open filters is near the filters menu
  .mobile-bottom-menu.fixed.bottom-0.right-0.w-full.pointer-events-none.flex.items-center.pb-ios.md-pb-0
    .flex-1.mr-18.flex.justify-end
      slot(name="left")
    .w-40
      slot(name="center")
    .flex-1.ml-18.md-hidden
      slot(name="right")

  //- alternative:
  //- use top so btns move "down" on ios when screen shrinks
  //- .mobile-bottom-menu.fixed.right-0.w-full.pointer-events-none.flex.items-center(style="top: 76vh")
</template>

<script>
export default {
  name: 'MobileBottomMenu'
}
</script>

<style>
</style>
